module.exports = __webpack_public_path__ + "static/media/social.150ad925.png";